import { render } from "./account.vue?vue&type=template&id=3eed5a38"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\pool_11_24\\pool_11_24\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__